// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-media-connect-container {
  margin: 20px;
}

.social-media-connect-container h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #232323;
  font-weight: 600;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.beta-badge {
  background-color: #5616ea;
  color: white;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  top: -4px;
}

.social-media-connect-container > p {
  color: #666;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.social-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
  max-width: 900px;
}

.social-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.social-info-box p {
  margin: 0;
}

.social-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.social-platforms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 1.5rem;
  align-items: stretch;
}

.social-platform-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  padding-top: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
}

.social-platform-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.platform-card-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: flex-end;
}

.platform-icon {
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
}

.platform-icon.facebook {
  color: #1877f2;
}

.platform-icon.instagram {
  color: #E4405F;
}

.platform-icon.whatsapp {
  color: #25D366;
}

.platform-icon.slack {
  /* SlackLogo is an inline SVG with hard-coded brand fills; no color/font
     inheritance needed. Keeping the class for layout symmetry with the
     other platform-icon-* rules. */
}

.platform-icon.telegram {
  color: #229ED9;
}

.social-platform-card h3 {
  font-size: 1.5rem;
  color: #333;
}

.social-platform-card p {
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.unassigned-warning {
  background-color: #fff9e1;
  color: #554002;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  text-align: center;
  border-left: 4px solid #ffc107;
}

.assigned-success {
  background-color: #f3eaff;
  color: #3d0d99;
  padding: 10px 16px;
  border-radius: 12px;
  font-weight: 600;
  margin-bottom: 0rem;
  font-size: 0.9rem;
  text-align: center;
  border-left: 4px solid #5616ea;
  margin-bottom: 1rem;
}

.unassigned-warning + .button-group,
.assigned-success + .unassigned-warning {
  margin-top: 0;
}

.assigned-success + .unassigned-warning {
  margin-bottom: 1.5rem;
}

.expired-warning {
  display: flex;
  align-items: center;
  background-color: #fdecea;
  color: #611a15;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  border-left: 4px solid #e53935;
}

.unassigned-warning + .expired-warning {
  margin-top: -0.5rem;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.connect-button {
  padding: 12px 32px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: white;
  width: 100%;
}

.manage-button {
  padding: 12px 32px;
  border: 2px solid #5616ea;
  background: white;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  color: #5616ea;
  width: 100%;
}

.facebook-button {
  background: linear-gradient(135deg, #1877f2 0%, #0c63d4 100%);
}

.facebook-button:hover {
  background: linear-gradient(135deg, #0c63d4 0%, #084fa8 100%);
}

.manage-button:hover {
  background: #f3eaff;
  border-color: #5e0fb3;
}

/* Ensure not-allowed cursor shows for disabled assign buttons */
.disabled-button-wrapper {
  display: block;
  width: 100%;
  cursor: not-allowed;
}

.disabled-button-wrapper .MuiButton-root.Mui-disabled {
  pointer-events: none; /* prevent hover events from overriding cursor */
}

@media (max-width: 768px) {
  .social-platforms-grid {
    grid-template-columns: 1fr;
  }

  .social-media-connect-container h2 {
    font-size: 1.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/socialMediaConnect.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;mCAEiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB,EAAE,gDAAgD;AACxE;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".social-media-connect-container {\r\n  margin: 20px;\r\n}\r\n\r\n.social-media-connect-container h2 {\r\n  font-size: 2rem;\r\n  margin-bottom: 1rem;\r\n  color: #232323;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.beta-badge {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  position: relative;\r\n  top: -4px;\r\n}\r\n\r\n.social-media-connect-container > p {\r\n  color: #666;\r\n  margin-bottom: 2rem;\r\n  font-size: 1rem;\r\n}\r\n\r\n.social-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n  max-width: 900px;\r\n}\r\n\r\n.social-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.social-info-box p {\r\n  margin: 0;\r\n}\r\n\r\n.social-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.social-platforms-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 2rem;\r\n  margin-top: 1.5rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.social-platform-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  padding-top: 1rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  transition: box-shadow 0.2s;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.social-platform-card:hover {\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.platform-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.platform-icon {\r\n  margin: 0 auto 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 4rem;\r\n}\r\n\r\n.platform-icon.facebook {\r\n  color: #1877f2;\r\n}\r\n\r\n.platform-icon.instagram {\r\n  color: #E4405F;\r\n}\r\n\r\n.platform-icon.whatsapp {\r\n  color: #25D366;\r\n}\r\n\r\n.platform-icon.slack {\r\n  /* SlackLogo is an inline SVG with hard-coded brand fills; no color/font\r\n     inheritance needed. Keeping the class for layout symmetry with the\r\n     other platform-icon-* rules. */\r\n}\r\n\r\n.platform-icon.telegram {\r\n  color: #229ED9;\r\n}\r\n\r\n.social-platform-card h3 {\r\n  font-size: 1.5rem;\r\n  color: #333;\r\n}\r\n\r\n.social-platform-card p {\r\n  color: #666;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.unassigned-warning {\r\n  background-color: #fff9e1;\r\n  color: #554002;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n  border-left: 4px solid #ffc107;\r\n}\r\n\r\n.assigned-success {\r\n  background-color: #f3eaff;\r\n  color: #3d0d99;\r\n  padding: 10px 16px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  margin-bottom: 0rem;\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n  border-left: 4px solid #5616ea;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.unassigned-warning + .button-group,\r\n.assigned-success + .unassigned-warning {\r\n  margin-top: 0;\r\n}\r\n\r\n.assigned-success + .unassigned-warning {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.expired-warning {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #fdecea;\r\n  color: #611a15;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 0.9rem;\r\n  border-left: 4px solid #e53935;\r\n}\r\n\r\n.unassigned-warning + .expired-warning {\r\n  margin-top: -0.5rem;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n}\r\n\r\n.connect-button {\r\n  padding: 12px 32px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  color: white;\r\n  width: 100%;\r\n}\r\n\r\n.manage-button {\r\n  padding: 12px 32px;\r\n  border: 2px solid #5616ea;\r\n  background: white;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n  color: #5616ea;\r\n  width: 100%;\r\n}\r\n\r\n.facebook-button {\r\n  background: linear-gradient(135deg, #1877f2 0%, #0c63d4 100%);\r\n}\r\n\r\n.facebook-button:hover {\r\n  background: linear-gradient(135deg, #0c63d4 0%, #084fa8 100%);\r\n}\r\n\r\n.manage-button:hover {\r\n  background: #f3eaff;\r\n  border-color: #5e0fb3;\r\n}\r\n\r\n/* Ensure not-allowed cursor shows for disabled assign buttons */\r\n.disabled-button-wrapper {\r\n  display: block;\r\n  width: 100%;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.disabled-button-wrapper .MuiButton-root.Mui-disabled {\r\n  pointer-events: none; /* prevent hover events from overriding cursor */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .social-platforms-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .social-media-connect-container h2 {\r\n    font-size: 1.7rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
